
namespace GeniuzPOS.Administration {

    @Serenity.Decorators.registerClass()
    export class CsVatTypeDialog extends Serenity.EntityDialog<CsVatTypeRow, any> {
        protected getFormKey() { return CsVatTypeForm.formKey; }
        protected getIdProperty() { return CsVatTypeRow.idProperty; }
        protected getLocalTextPrefix() { return CsVatTypeRow.localTextPrefix; }
        protected getNameProperty() { return CsVatTypeRow.nameProperty; }
        protected getService() { return CsVatTypeService.baseUrl; }
        protected getDeletePermission() { return CsVatTypeRow.deletePermission; }
        protected getInsertPermission() { return CsVatTypeRow.insertPermission; }
        protected getUpdatePermission() { return CsVatTypeRow.updatePermission; }

        protected form = new CsVatTypeForm(this.idPrefix);

        protected afterLoadEntity() {
            super.afterLoadEntity();

            var Vatcode = Q.tryFirst(Product.CsSkuRow.getLookup().items,x => x.VatType == this.entity.VatType)
            if(Vatcode !=null){
                this.deleteButton.toggleClass('disabled', true);
                
            }

            if(this.form.VatType.value == 'N')
                this.deleteButton.toggleClass('disabled', true);
        }
        

    }
}